import { computed } from 'vue';

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'api',
    'Channel::Email': 'email',
    'Channel::FacebookPage': 'facebook',
    'Channel::Line': 'line',
    'Channel::Sms': 'sms',
    'Channel::Telegram': 'telegram',
    'Channel::TwilioSms': 'twilio',
    'Channel::TwitterProfile': 'twitter',
    'Channel::WebWidget': 'website',
    'Channel::Whatsapp': 'whatsapp',
    'Channel::Instagram': 'instagram',
    'Channel::SynphoneVoice': 'synvoice',
    'Channel::SynphoneMeet': 'synmeet',
  };

  const providerIconMap = {
    microsoft: 'i-ri-microsoft-fill',
    google: 'i-ri-google-fill',
  };

  const channelIcon = computed(() => {
    const type = inbox.channel_type;
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && inbox.provider) {
      if (Object.keys(providerIconMap).includes(inbox.provider)) {
        icon = providerIconMap[inbox.provider];
      }
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
